'use client';

import { BaseLineRight } from '@/app/components/icons/BaseLineRight';
import { cn } from '@/app/utils';
import { Link } from '@/i18n/routing';

interface BreadcrumbsProps {
  pathname: {
    label: string;
    href: string;
  }[];
  className?: string;
}

export default function Breadcrumbs({ pathname, className }: BreadcrumbsProps) {
  return (
    <section data-blog-breadcrumbs className="fixed top-[76px] z-10 w-full bg-black px-12 sm:top-[64px] sm:px-4">
      <nav className={cn('flex h-[80px] w-full items-center sm:h-[50px]', className)}>
        <div className="flex items-center gap-3 overflow-x-hidden sm:gap-1">
          {pathname.map((item, index) => (
            <div key={item.href} className="flex items-center gap-3 sm:gap-1">
              {index === pathname.length - 1 ? (
                <span className="font-medium text-white/60 text-xl leading-[140%] md:max-w-[120px] md:truncate md:text-sm">
                  {item.label}
                </span>
              ) : (
                <>
                  <Link
                    href={item.href}
                    prefetch={false}
                    className="font-medium text-white text-xl leading-[140%] md:max-w-[100px] md:truncate md:text-sm"
                  >
                    {item.label}
                  </Link>
                  <BaseLineRight className="size-6 text-white/60 sm:size-4" />
                </>
              )}
            </div>
          ))}
        </div>
      </nav>
    </section>
  );
}
